import jwtDecode from 'jwt-decode';
// routes
import { updateError } from 'src/redux/slices/user';
//
import axios from './axios';
import { dispatch } from '../redux/store';
// ----------------------------------------------------------------------

const isValidToken = (accessToken) => {
    if (!accessToken) {
        return false;
    }
    const decoded = jwtDecode(accessToken);

    const currentTime = Date.now() / 1000;

    return decoded.exp > currentTime;
};

let accessExpiredTimer;
let refreshExpiredTimer;

const handleTokenExpired = (exp, isRefresh) => {
    const currentTime = Date.now() / 1000;
    let timeLeft = (exp - currentTime) * 1000;
    if (isRefresh) timeLeft = Math.max(0, timeLeft - 60000);

    if (isRefresh) {
        clearTimeout(refreshExpiredTimer);
        refreshExpiredTimer = setTimeout(() => {
            dispatch(updateError({
                message: 'Please login again! Session will close in 1 minute',
                success: "warning"
            }));
        }, timeLeft);
    } else {
        // Access-token expiry is handled silently: the API interceptor catches
        // the 401 and runs the refresh flow. No user-visible toast — if refresh
        // itself fails, the refresh-expired branch above fires the "please
        // login again" warning.
        clearTimeout(accessExpiredTimer);
    }
};

const clearSessionTimers = () => {
    clearTimeout(accessExpiredTimer);
    clearTimeout(refreshExpiredTimer);
};

const setSession = (accessToken, refreshToken) => {
    if (accessToken) {
        localStorage.setItem('refreshToken', refreshToken);
        localStorage.setItem('accessToken', accessToken);
        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

        // This function below will handle when token is expired
        const { exp } = jwtDecode(accessToken); // ~3 days by minimals server
        const { exp: rexp } = jwtDecode(refreshToken);
        handleTokenExpired(exp, false);
        handleTokenExpired(rexp, true);
    } else {
        // RCA guard: timers MUST be cleared here. Without this, leaked timers
        // from handleTokenExpired survive logout and fire updateError dispatches
        // into a logged-out app, which the Sentry Redux enhancer captures.
        clearSessionTimers();
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        delete axios.defaults.headers.common.Authorization;
    }
};

export { isValidToken, setSession, clearSessionTimers };
